import { PageUtils } from "./helpers/page-utils";

document.addEventListener('DOMContentLoaded', function () {
    const googleMaps = document.querySelectorAll('div[data-google-map]');

    if (googleMaps.length) {
        function highlightTarget(targetSelector) {
            // Remove '#' before using getElementById
            const cleanId = targetSelector.startsWith('#') ? targetSelector.slice(1) : targetSelector;
            const targetElement = document.getElementById(cleanId);

            if (targetElement) {
                targetElement.classList.add('animate-highlight-card');
                PageUtils.scrollToTarget(targetElement);

                setTimeout(() => {
                    targetElement.classList.remove('animate-highlight-card');
                }, 5000);
            }
        }


        for (const googleMap of googleMaps) {
            googleMap.addEventListener('click', function (event) {
                const link = event.target.closest('[data-highlight-target]');
                if (link) {
                    let targetSelector = link.getAttribute('data-destination');
                    if (targetSelector && targetSelector.startsWith('#')) {
                        highlightTarget(targetSelector);
                    }
                }
            });
        }
    }
});
